// extracted by mini-css-extract-plugin
export default {"root":"styles_root__JS5zv","linksContainer":"styles_linksContainer__stHQe","terms":"styles_terms__3bwD-","blueLink":"styles_blueLink__9hZ0h","noLink":"styles_noLink__1kgn1"};